const ShownPanelsEnum = {
  None: 'None',
  Search: 'Search',
  AddNewItem: 'AddNewItem',
  AddNewSubItem: 'AddNewSubItem',
  EditItem: 'EditItem',
  EditMainItem: 'EditMainItem',
  EditSubItem: 'EditSubItem',
  MultiEdit: 'MultiEdit',
  StatusUpdate: 'StatusUpdate',
  MassStatusUpdate: 'MassStatusUpdate',
  Export: 'Export',
  MassUpload: 'MassUpload',
  FileUpload: 'FileUpload',
  EditContent: 'EditContent',
  Remove: 'Remove',
  EditGlobal: 'EditGlobal',
  EditGeneral: 'EditGeneral',
  EditFIC: 'EditFIC',
  EditContact: 'EditContact',
  EditCorporate: 'EditCorporate',
  EditEmployee: 'EditEmployee',
  EditVideo: 'EditVideo',
  Repeat: 'Repeat',
  Close: 'Close',
  Refresh: 'Refresh',
  GenerateInvoice: 'GenerateInvoice',
  Details: 'Details',
  Tax: 'Tax',
  Copy: 'Copy',
  Navigate: 'Navigate',
  ApplyCredit: 'ApplyCredit',
  ApplyTaxCredit: 'ApplyTaxCredit',
  ApplyReimbursementTaxCredit: 'ApplyReimbursementTaxCredit',
  UnapplyTaxCredit: 'UnapplyTaxCredit',
  ApplyLateFeeCredit: 'ApplyLateFeeCredit',
  UnapplyLateFeeCredit: 'UnapplyLateFeeCredit',
  Void: 'Void',
  VoidAndReissue: 'Void & Reissue',
  VoidAndSuppress: 'Void & Suppress',
  ResendStatement: 'Resend Statement',
  ReconcileExport: 'Reconcile Export Payments',
  QboInvoiceExport: 'QBO Invoice Export',
  QboCreditMemoExport: 'QBO Credit Memo Export',
  EOMExport: 'EOM Export',
  AdHocExport: 'Ad Hoc Export',
  Import: 'Import',
  GetIP: 'Get Public IP',
  MissedInvoiceEmail: 'Missed Invoices Email',
  BulkFinalize: 'Bulk Finalization',
  FinalizeSelected: 'Finalize Selected',
  CreateCreditMemo: 'Create Credit Memo',
  ApplyPayment: 'Apply Payment',
  AddNewPayment: 'Add New Payment',
  Refund: 'Refund',
  DetailedTaxWindow: 'Detailed Tax Window',
  CopyFrom: 'Copy From',
  ExcelDataExport: 'Excel Data Export',
  ShowAll: 'ShowAll',
  SomethingElse: 'SomethingElse',
  Delete: 'Delete',
  AddNewParent: 'AddNewParent',
  AddBareManager: 'Add Bare Manager',
  AddClientManager: 'Add Client Manager',
  UserSetTimesheetUser: 'User Set Timesheet User',
  AssociateTpSurvey: 'Associate Third-Party Survey',
  SecurityChecklist: 'Security Checklist',
  EditSecurityChecklist: 'Edit Security Checklist',
  CopySecurityChecklist: 'Copy Security Checklist',
  SendScheduleEdLink: 'Send Schedule D/E Link',
  Finalize: 'Finalize',
  AddNewInvoice: 'AddNewInvoice',
  AddNewTpPayment: 'AddNewTpPayment',
  ARAgeingReport: 'AR Ageing Report',
  ForceUploadToTpInstance: 'Force Upload to TP Instance',
  EvaluatorPaymentsExport: 'Approved Evaluator Payments Export',
  TpRevenueByRevenuePeriodReport: 'TP Revenue by Revenue Period Report',
  UnappliedPrepaymentReport: 'Unapplied Prepayment Report',
  EvaluatorLeadReport: 'Evaluator Lead Report',
  EvaluatorCountReport: 'Evaluator Count Report',
  ClientPOCExport: 'Client POC Export',
  OpportunityPOCExport: 'Opportunity POC Export',
  AddExternalQuestionaire: 'AddExternalQuestionaire',
  ContractedOverride: 'ContractedOverride',
  ContractedReset: 'ContractedReset',
  DateUnlock: 'DateUnlock',
  DateLock: 'DateLock',
  Rollover: 'Rollover',
  EditCostGroupSetting: 'EditCostGroupSetting',
  EditCostGroupLink: 'EditCostGroupLink',
  PlanningAssignmentEdit: 'PlanningAssignmentEdit',
  ServiceAccountManagerEdit: 'ServiceAccountManagerEdit',
  DownloadTemplate: 'DownloadTemplate',
  UploadAssignments: 'UploadAssignments',
  GenerateEvaluatorIob: 'GenerateEvaluatorIob',
  PlatformCostOverride: 'PlatformCostOverride',
  RunPlatformCost: 'RunPlatformCost',
  InvoiceAutomationRun: 'InvoiceAutomationRun',
};

export default ShownPanelsEnum;
